import ProjectService from '../../../services/project.service'
import { Project } from '../../../types'
import { updateTaskChangedFields } from './taskPayload'

type TaskStatusLike = {
    key: string
    position: number
}

function getRelatedTasks(task: any) {
    return Array.isArray(task?.relatedTasks)
        ? task.relatedTasks.filter((currentTask: any) => Boolean(currentTask?.id))
        : []
}

function getTargetStatus(task: any, targetStatuses: TaskStatusLike[], fallbackStatusKey: string) {
    if (!targetStatuses.length) {
        return task?.status || ''
    }

    if (targetStatuses.some((status) => status.key === task?.status)) {
        return task.status
    }

    return fallbackStatusKey || task?.status || ''
}

function getFallbackStatusKey(targetStatuses: TaskStatusLike[]) {
    if (!targetStatuses.length) {
        return ''
    }

    return [...targetStatuses].sort((a, b) => a.position - b.position)[0]?.key || ''
}

async function getTargetStatuses(targetProject: Project): Promise<TaskStatusLike[]> {
    if (Array.isArray(targetProject.task_statuses) && targetProject.task_statuses.length) {
        return targetProject.task_statuses
    }

    try {
        return await ProjectService.getSortedTaskStatuses(String(targetProject.id))
    } catch (error) {
        console.error('Failed to load target project task statuses:', error)
        return []
    }
}

export async function moveTaskToProject(task: any, currentProjectId: number, targetProject: Project) {
    const targetStatuses = await getTargetStatuses(targetProject)
    const fallbackStatusKey = getFallbackStatusKey(targetStatuses)
    const targetProjectId = Number(targetProject.id)
    const updatedTask = await updateTaskChangedFields(task.id, currentProjectId, {
        project_id: targetProjectId,
        status: getTargetStatus(task, targetStatuses, fallbackStatusKey),
    })

    await Promise.all(getRelatedTasks(task).map((relatedTask: any) => (
        updateTaskChangedFields(relatedTask.id, currentProjectId, {
            parent_id: task.id,
            project_id: targetProjectId,
            status: getTargetStatus(relatedTask, targetStatuses, fallbackStatusKey),
        })
    )))

    return updatedTask
}
